import script from "./AppMenuTopBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppMenuTopBar.vue?vue&type=script&lang=ts&setup=true"

import "./AppMenuTopBar.vue?vue&type=style&index=0&id=c8e5d672&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8e5d672"]])

export default __exports__